var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "100%",
    x2: "50%",
    y2: "-49.891%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E92B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCFFA8",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(132 81.627 166.164)",
    d: "M2 323l10.598 13L23 323z",
    stroke: "url(#a)",
    strokeWidth: 2,
    fill: "none",
    opacity: 0.659
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape2);
export default __webpack_public_path__ + "static/media/shape2.80eec00c0b9edc4c0f4df16007335406.svg";
export { ForwardRef as ReactComponent };